import clienteAxios from "../config/axios";

// ============ RESERVAS ============

export async function getSlotsDisponibles(activoID, fecha) {
  return clienteAxios.get(`/cancha-reservas/slots-disponibles`, {
    params: { activoID, fecha },
  });
}

export async function getSlotsTodasCanchas(activoIDs, fecha) {
  return clienteAxios.get(`/cancha-reservas/disponibilidad-canchas`, {
    params: { activoIDs: JSON.stringify(activoIDs), fecha },
  });
}

export async function getMisReservas(soloFuturas = true, estado = null, incluirComoJugador = false) {
  const params = { soloFuturas };
  if (estado) {
    params.estado = estado;
  }
  if (incluirComoJugador) {
    params.incluirComoJugador = true;
  }
  return clienteAxios.get(`/cancha-reservas/mis-reservas`, { params });
}

export async function getAllReservas(fechaDesde, fechaHasta, activoID = null) {
  const params = {};
  if (fechaDesde) params.fechaDesde = fechaDesde;
  if (fechaHasta) params.fechaHasta = fechaHasta;
  if (activoID) params.activoID = activoID;
  return clienteAxios.get(`/cancha-reservas`, { params });
}

export async function getReservaById(id) {
  return clienteAxios.get(`/cancha-reservas/${id}`);
}

export async function createReserva(reservaData) {
  return clienteAxios.post(`/cancha-reservas`, reservaData);
}

export async function updateReserva(id, reservaData) {
  return clienteAxios.put(`/cancha-reservas/${id}`, reservaData);
}

export async function cancelarReserva(id, motivo) {
  return clienteAxios.put(`/cancha-reservas/${id}/cancelar`, { motivo });
}

export async function suspenderReserva(id, motivo) {
  return clienteAxios.put(`/cancha-reservas/${id}/suspender`, { motivo });
}

export async function reactivarReserva(id) {
  return clienteAxios.put(`/cancha-reservas/${id}/reactivar`);
}

export async function deleteReserva(id) {
  return clienteAxios.delete(`/cancha-reservas/${id}`);
}

export async function getEstadisticas(fechaDesde, fechaHasta) {
  const params = {};
  if (fechaDesde) params.fechaDesde = fechaDesde;
  if (fechaHasta) params.fechaHasta = fechaHasta;
  return clienteAxios.get(`/cancha-reservas/estadisticas`, { params });
}

export async function getEstadisticasPorTipo(fechaDesde, fechaHasta) {
  const params = {};
  if (fechaDesde) params.fechaDesde = fechaDesde;
  if (fechaHasta) params.fechaHasta = fechaHasta;
  return clienteAxios.get(`/cancha-reservas/estadisticas-por-tipo`, { params });
}

export async function getJugadoresObservados() {
  return clienteAxios.get(`/cancha-reservas/jugadores-observados`);
}

export async function aplicarPropuestaOptimizacion({ activoID, fecha, movimientos }) {
  return clienteAxios.post(`/cancha-reservas/aplicar-propuesta`, {
    activoID,
    fecha,
    movimientos,
  });
}

// ============ DISPONIBILIDAD ============

export async function getAllDisponibilidades() {
  return clienteAxios.get(`/cancha-disponibilidad`);
}

export async function getDisponibilidadById(id) {
  return clienteAxios.get(`/cancha-disponibilidad/${id}`);
}

export async function getDisponibilidadByActivoId(activoID) {
  return clienteAxios.get(`/cancha-disponibilidad/by-activo/${activoID}`);
}

export async function createDisponibilidad(configData) {
  return clienteAxios.post(`/cancha-disponibilidad`, configData);
}

export async function createDisponibilidadDefault(activoID, codActivo) {
  return clienteAxios.post(`/cancha-disponibilidad/default`, {
    activoID,
    codActivo,
  });
}

export async function updateDisponibilidad(id, configData) {
  return clienteAxios.put(`/cancha-disponibilidad/${id}`, configData);
}

export async function toggleDisponibilidadActivo(id) {
  return clienteAxios.put(`/cancha-disponibilidad/${id}/toggle-activo`);
}

export async function deleteDisponibilidad(id) {
  return clienteAxios.delete(`/cancha-disponibilidad/${id}`);
}

// ============ BLOQUEOS ============

export async function getAllBloqueos(estado = null) {
  const params = {};
  if (estado) params.estado = estado;
  return clienteAxios.get(`/cancha-bloqueos`, { params });
}

export async function getBloqueoById(id) {
  return clienteAxios.get(`/cancha-bloqueos/${id}`);
}

export async function getBloqueosByActivoAndFecha(activoID, fecha) {
  return clienteAxios.get(`/cancha-bloqueos/by-activo/${activoID}`, {
    params: { fecha },
  });
}

export async function createBloqueo(bloqueoData) {
  return clienteAxios.post(`/cancha-bloqueos`, bloqueoData);
}

export async function updateBloqueo(id, bloqueoData) {
  return clienteAxios.put(`/cancha-bloqueos/${id}`, bloqueoData);
}

export async function cancelarBloqueo(id) {
  return clienteAxios.put(`/cancha-bloqueos/${id}/cancelar`);
}

export async function completarBloqueo(id) {
  return clienteAxios.put(`/cancha-bloqueos/${id}/completar`);
}

export async function deleteBloqueo(id) {
  return clienteAxios.delete(`/cancha-bloqueos/${id}`);
}
